/* Release card: days left for group buys + live progress from the Updates page. */
(() => {
  const DAY = 86400000;
  const daysLeft = (card) => {
    const fact = card.querySelector('[data-rc-ends]');
    if (!fact || !fact.dataset.rcEnds) return;
    const [y, m, d] = fact.dataset.rcEnds.split('-').map(Number);
    if (!y) return;
    const end = new Date(y, m - 1, d, 23, 59, 59);
    const diff = Math.ceil((end - new Date()) / DAY);
    const left = fact.querySelector('[data-rc-left]');
    const label = fact.querySelector('[data-rc-ends-label]');
    if (diff < 1 && end < new Date()) { label.textContent = 'Group buy closed'; left.textContent = ''; card.classList.add('is-closed'); return; }
    left.textContent = diff <= 1 ? 'Closes today' : diff + ' days left';
    if (diff <= 3) left.classList.add('is-soon');
    left.hidden = false;
  };
  const withPreview = (path) => {
    const url = new URL(path, location.origin);
    const id = new URLSearchParams(location.search).get('preview_theme_id') || (window.Shopify && Shopify.designMode && Shopify.theme ? Shopify.theme.id : null);
    if (id) url.searchParams.set('preview_theme_id', id);
    return url.toString();
  };
  const progress = async (card) => {
    const handle = card.dataset.handle;
    if (!handle) return;
    try {
      const res = await fetch(withPreview(card.dataset.updatesUrl), { credentials: 'same-origin' });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const row = [...doc.querySelectorAll('[data-handle]')].find((r) => r.dataset.handle === handle);
      if (!row) return;
      const stage = Math.max(0, Math.min(6, parseInt(row.dataset.stage, 10) || 0));
      const box = card.querySelector('[data-rc-progress]');
      card.querySelector('[data-rc-status]').textContent = row.dataset.status || '';
      if (row.dataset.date) card.querySelector('[data-rc-date]').textContent = 'Updated ' + row.dataset.date;
      card.querySelector('[data-rc-bar]').setAttribute('aria-label', stage + ' of 6 stages complete: ' + (row.dataset.status || ''));
      card.querySelectorAll('[data-rc-step]').forEach((s) => {
        const n = +s.dataset.rcStep;
        s.classList.toggle('is-done', n <= stage);
        s.classList.toggle('is-now', n === stage + 1);
      });
      if (row.dataset.note) { const note = card.querySelector('[data-rc-note]'); note.textContent = row.dataset.note; note.hidden = false; }
      box.hidden = false;
      card.querySelector('[data-rc-track]').hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => card.classList.add('is-ready')));
    } catch (e) { /* card still shows dates */ }
  };
  const init = (scope) => (scope || document).querySelectorAll('[data-qq-rc]').forEach((card) => {
    if (card.dataset.ready) return; card.dataset.ready = '1';
    daysLeft(card); progress(card);
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
